import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import NavSection from '../../../components/nav-section';
import LogoutAndProfileButton from 'src/components/logout_and_profile_button';
import navConfig from './config';
import config from 'src/config';
import { getKey } from 'src/services/auth.service';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
// import UserRefer from 'src/components/user-refer';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <>
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', justifyContent: 'center', color: 'gray' }}>
        <img src='/assets/images/logo.png' alt='logo' style={{width: '100px'}} />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <AccountBoxIcon alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {getKey('username')}
              </Typography>

              {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography> */}
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ marginX: 5, marginY: 2 }}>
        
        <LogoutAndProfileButton />

        {/* <UserRefer /> */}

        {/* <Button
          variant="contained"
          size="small"
          href="https://forms.office.com/pages/responsepage.aspx?id=jb4g5qJg2kSahWjFLAr9DRqtKCpST8FHlcrpuHD3YChUQ1FUSFVIQ001VUlXSUhWWjI1ME9SNTVJOC4u&route=shorturl"
          sx={{mb: 2}}
          target="_blank"
          fullWidth
        >
          Give Feedback
        </Button> */}

        {/* <Button
          variant="outlined"
          size="small"
          href="https://bit.ly/4id7WKO"
          target="_blank"
          fullWidth
        >
          Contact Support
        </Button> */}
      </Box>


      <Box sx={{ pb: 2, textAlign: 'center' }}>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          v{config.APP_VERSION}
        </Typography>
      </Box>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: 0 },
      }}
    >
      {/* {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : ( */}
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      {/* )} */}
    </Box>
  );
}
